import { render, staticRenderFns } from "./DialogChangePassword.vue?vue&type=template&id=9fa7803c"
import script from "./DialogChangePassword.vue?vue&type=script&lang=js"
export * from "./DialogChangePassword.vue?vue&type=script&lang=js"
import style0 from "./DialogChangePassword.vue?vue&type=style&index=0&id=9fa7803c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports